/* eslint-disable no-param-reassign */
import React, { useEffect, useState, useMemo } from "react";
import { VbzModal, VbzLoadingLogo } from "@smiles/voebiz-ui-kit";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useAuth0 } from "@auth0/auth0-react";

import { PhoneType, useUser } from "../../../context/UserContext";

import { ModalError } from "../../../components";

import { createMember } from "../../../services/createMember";

const Loader = () => {
  const ldFlags = useFlags();
  const { loginWithRedirect } = useAuth0();
  const { data } = useUser();
  const history = useHistory();
  const path = "/cadastro";
  const { t } = useTranslation("register_admin");
  const [errorType, setErrorType] = useState("generic_error");
  const [isError, setIsError] = useState(false);

  const multiValidationPhoneField = (phoneItem: PhoneType) => {
    const { number: phoneNumber } = phoneItem;
    const invalidCaracters = ["(", ")", "-"];
    if (invalidCaracters.find((caracter) => phoneNumber.includes(caracter))) {
      const areaCodeMatch = phoneNumber.match(/\((\d{2})\)/);
      const areaCode = areaCodeMatch ? Number(areaCodeMatch[1]) : 0;
      const cleanNumber = phoneNumber.replace(/\D/g, "").slice(-9);

      return {
        ...phoneItem,
        areaCode,
        number: cleanNumber,
      };
    }

    return phoneItem;
  };

  const createMemberService = async () => {
    const newMember = {
      ...data,
      phoneList: (data.phoneList as PhoneType[]).map(multiValidationPhoneField),
    };
    delete newMember.smilesToken;
    delete newMember.adminName;
    delete newMember.phoneNumber1;
    delete newMember.phoneNumber2;
    delete newMember.cnpj;
    delete newMember.apiDomain;
    delete newMember.occupationDataData;

    //comentar pra rodar local

    const { apiDomain } = ldFlags;
    // const apiDomain = "https://apigw-voebiz-hml5.smiles.com.br";

    const smlToken = data.smilesToken;
    const createMemberServiceResponse = await createMember(newMember, smlToken, apiDomain);
    if (createMemberServiceResponse.status === 200) {
      history.push(`${path}/sucesso`);
    }
    if (createMemberServiceResponse.response.status === 401) {
      const errorCode = createMemberServiceResponse.response.data.data.user_message.code;
      setIsError(true);
      if (errorCode === 1) {
        setErrorType("already_registered_CNPJ_error");
      }
      if (errorCode === 2) {
        setErrorType("already_registered_CPF_error");
      }
      if (errorCode === 3) {
        setErrorType("already_registered_EMAIL_error");
      }
    } else {
      setIsError(true);
      setErrorType("generic_error");
    }
  };
  const login = () => {
    loginWithRedirect({
      redirectUri: `${window.location.origin}/validar`,
    });
  };
  const getError = () => {
    if (errorType === "already_registered_CNPJ_error") {
      return {
        onClickPrimary: () => {
          history.push(`${path}`);
        },
        errorTitle: t("already_registered_CNPJ_error"),

        errorMsg: (
          <strong>
            Por favor, tente de novo ou entre em contato com a{" "}
            <span>
              <a href="/atendimento"> Central de Atendimento VoeBiz. </a>
            </span>
          </strong>
        ),
        idMessage: "lbl_msgInformativeCnpjExisting_1",
        handleCloseModal: () => {
          history.push(`${path}`);
        },

        onClickSecondary: () => {
          // login();
          setErrorType("possible_reasons_error");
        },
        btnTextPrimary: t("try_again"),
        btnPrimaryColor: "primary",

        btnTextSecondary: t("access_account_link"),
        btnIdPrimary: "btn_retrievePassword",
        idTitle: "lbl_titleCnpjExisting",
        btnIdSecondary: "btn_enterMyAccount",
      };
    }

    if (errorType === "already_registered_CPF_error") {
      return {
        handleCloseModal: () => {
          history.push(`${path}`);
        },
        errorTitle: t("already_registered_CPF"),
        idTitle: "lbl_titleCPFExisting",
        btnPrimaryColor: "primary",
        btnTextSecondary: t("access_account_link_CPF"),
        errorMsg: (
          <strong>
            Por favor, tente de novo ou entre em contato com a{" "}
            <span>
              <a href="/atendimento"> Central de Atendimento VoeBiz. </a>
            </span>
          </strong>
        ),
        idMessage: "lbl_msgInformativeCpfExisting_1",

        onClickSecondary: () => {
          // aqui que tem que trocar

          // login();
          setErrorType("possible_reasons_error");
        },
        btnTextPrimary: t("try_again_CPF"),

        btnIdPrimary: "btn_retrievePassword_CPF",
        btnIdSecondary: "btn_enterMyAccount_CPF",
        onClickPrimary: () => {
          history.push(`${path}`);
        },
      };
    }

    if (errorType === "already_registered_EMAIL_error") {
      return {
        errorMsg: (
          <strong>
            Por favor, tente de novo ou entre em contato com a{" "}
            <span>
              <a href="/atendimento"> Central de Atendimento VoeBiz. </a>
            </span>
          </strong>
        ),
        errorTitle: t("already_registered_email"),
        idTitle: "lbl_titleEmailExisting",

        idMessage: "lbl_msgInformativeEmailExisting_1",
        onClickSecondary: () => {
          // login();
          setErrorType("possible_reasons_error");
        },

        onClickPrimary: () => {
          history.push(`${path}`);
        },

        btnTextPrimary: t("try_again_email"),
        handleCloseModal: () => {
          history.push(`${path}`);
        },
        btnPrimaryColor: "primary",
        btnTextSecondary: t("access_account_link_email"),
        btnIdPrimary: "btn_retrievePassword",
        btnIdSecondary: "btn_enterMyAccount",
      };
    }

    if (errorType === "possible_reasons_error") {
      return {
        errorMsg: (
          <div>
            <strong>O CNPJ está incorreto:</strong>
            <span>
              <br /> Verifique se você digitou o número correto e tente de novo
            </span>
            <strong>
              <br />
              <br />O CNPJ já foi cadastrado:
            </strong>
            <span>
              <br />
              Verifique se a empresa já possui cadastro no VoeBiz e{" "}
              <a
                onClick={() => {
                  login();
                }}
              >
                {" "}
                acesse a conta{" "}
              </a>
              <br />
            </span>
            <strong>
              <br />O CPF ou e-mail já foi cadastrado:
            </strong>
            <span>
              <br />
              Verifique se o CPF ou e-mail do gestor da conta já estão cadastrados em outra conta.
            </span>
            <strong>
              <br />
              <br />
              <br />
              <br />
              Ainda precisa de ajuda?{" "}
            </strong>
            <span>
              Entre em contato com a <a href="/atendimento"> Central de Atendimento VoeBiz. </a>
            </span>
          </div>
        ),
        errorTitle: t("possible_reasons_error"),
        btnTextPrimary: t("try_again"),

        onClickPrimary: () => {
          history.push(`${path}`);
        },

        handleCloseModal: () => {
          history.push(`${path}`);
        },
        btnPrimaryColor: "primary",
        //  btnTextSecondary: t("access_account_link_email"),
        //  btnIdPrimary: "btn_retrievePassword",
        //  btnIdSecondary: "btn_enterMyAccount",
      };
    }

    return {
      errorTitle: t("generic_error"),
      idTitle: "lbl_titleCnpjExisting",
      errorMsg: t("generic_error_description"),
      idMessage: "lbl_msgInformativeCnpjExisting_1",
      handleCloseModal: () => {
        history.push(`${path}`);
      },
      onClickPrimary: () => {
        history.push(`${path}`);
      },
      btnTextPrimary: t("generic_error_btn_text"),
      btnPrimaryColor: "primary",
      btnIdPrimary: "btn_retrievePassword",
    };
  };
  const modalErrorData = useMemo(() => getError(), [errorType]);
  useEffect(() => {
    createMemberService();
  }, []);
  return (
    <>
      <VbzModal
        hideHeader
        className="LoadingModal"
        desktopSize="big"
        contentClassName="LoadingModal_content"
        modalColor="light"
        id="idLoading"
        type="full"
        isOpen
      >
        <div className="LoadingModal_wrapper">
          <div className="LoadingModal_wrapper_loader">
            <VbzLoadingLogo id="loader" />
          </div>
          <span className="LoadingModal_wrapper_text-loading">Um momento </span>
        </div>
      </VbzModal>
      <ModalError
        {...modalErrorData}
        isOpen={isError}
        onClosed={() => {
          setIsError(false);
        }}
        btnPrimaryColor={
          modalErrorData?.btnPrimaryColor && modalErrorData?.btnPrimaryColor === "secondary" ? "secondary" : "primary"
        }
      />
    </>
  );
};
export default Loader;
